import { ArticleCard, Box, Button, Flex } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Advertisements } from '../../Advertisements';
import { getItemProps as getArticleCardProps } from '../../ArticleCardList';
import { ArticleCardLoading } from '../../Loading';
import { Section } from '../../Section';
import { useAdsQuery } from '../../../utils/hooks';
import takeMap from '../../../utils/takeMap';

const Title = styled(Box)`
  font-size: ${themeGet('fontSizes.h2')};
  line-height: 1.42;
`;

const ListFlex = styled(Flex)`
  & > :last-child {
    margin: 0;
  }
`;

const GET_HOME_DATA = gql`
  query getHomeDate {
    news: hkdutest_news(limit: 4, order_by: { created_at: desc }) {
      id
      author {
        real_avatar
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      tags {
        tag {
          name
        }
      }
      created_at
    }
    eHealths: hkdutest_e_health(limit: 6, order_by: { created_at: desc }) {
      id
      author {
        real_avatar
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      tags {
        tag {
          name
        }
      }
      created_at
    }
  }
`;

const Home = ({ uri }) => {
  const { ads } = useAdsQuery(uri);
  return (
    <Query query={GET_HOME_DATA}>
      {({ data, loading }) => {
        const news = R.propOr([], 'news', data);
        const eHealths = R.propOr([], 'eHealths', data);

        return (
          <Flex flexDirection="column">
            <Helmet>
              <title>Home - HKDU Public</title>
            </Helmet>
            <Advertisements ads={ads} itemProps={{ height: ['150px', '300px'] }} />
            <Section>
              <Box px={[5, 0]} py={8}>
                <Flex flexDirection="column">
                  <Box mb={8}>
                    <Box mb={6}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Title>What's New</Title>
                        {R.gt(news.length, 3) && (
                          <Button size="small" as={Link} to="/public/news">
                            More
                          </Button>
                        )}
                      </Flex>
                    </Box>
                    <ListFlex flexDirection={['column', 'row']}>
                      {loading &&
                        R.map(
                          x => (
                            <Box key={`news-articlecard-${x}`} mb={[5, 0]} mr={[0, 5]} width={[1, 1 / 3]}>
                              <ArticleCardLoading flexDirection="column" />
                            </Box>
                          ),
                          R.range(0, 3)
                        )}
                      {takeMap(3, item => (
                        <Box key={item.id} mb={[5, 0]} mr={[0, 5]} width={[1, 1 / 3]}>
                          <ArticleCard
                            as={Link}
                            to={`/public/news/${R.propOr('', 'id', item)}`}
                            {...getArticleCardProps({
                              item,
                              uri: '/public/news',
                            })}
                            height="389px"
                            variant="vertical"
                          />
                        </Box>
                      ))(news)}
                    </ListFlex>
                  </Box>
                  {/* -------- E Health -------- */}
                  <Flex flexDirection="column">
                    <Box mb={6}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Title>E-Health</Title>
                        {R.gt(eHealths.length, 5) && (
                          <Button size="small" as={Link} to="/public/e-health">
                            More
                          </Button>
                        )}
                      </Flex>
                    </Box>
                    <ListFlex flexDirection="column">
                      {loading &&
                        R.map(
                          x => (
                            <Box key={`news-articlecard-${x}`} mb={5} height={['389px', '246px']}>
                              <ArticleCardLoading />
                            </Box>
                          ),
                          R.range(0, 5)
                        )}
                      {takeMap(5, item => (
                        <Box key={item.id} mb={5} height={['389px', '246px']}>
                          <ArticleCard
                            as={Link}
                            to={`/public/e-health/${R.propOr('', 'id', item)}`}
                            {...getArticleCardProps({
                              item,
                              uri: '/public/e-health',
                            })}
                          />
                        </Box>
                      ))(eHealths)}
                    </ListFlex>
                  </Flex>
                </Flex>
              </Box>
            </Section>
          </Flex>
        );
      }}
    </Query>
  );
};

export default Home;
